import styled from 'styled-components';

const Section = styled.section`
  display: flex;
  flex: 1;
  padding: 4rem 5rem;
`;

export default Section;
